import * as React from "react";
import {
  List,
  ListItem,
  Card as MuiCard,
  Typography,
  Box,
  Grid,
} from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";
import logo from "../../../src/assets/logo.png";
import backIcon from "../../../src/assets/icons/backIcon.svg";
import { useStyles } from "./style";
import AppNotificationIcon from "../Icons/AppNotificationIcon";
import HelpSupportIcon from "../Icons/HelpSupportIcon";
import AppLanguageSettingIcon from "../Icons/LanguageIcon";
import AppNotificationSetting from "./AppNotificationSetting";
interface GeneralScreenProps {
  handleGeneralAppSetting: (setting: string) => void; // The function now expects a string argument
}
function AppSetting({ handleGeneralAppSetting }: GeneralScreenProps) {
  const classes = useStyles();
  const history = useHistory();

  return (
    <>
      <div className={classes.container}>
        <MuiCard className={classes.card}>
          <Box className={classes.header}>
            <Link to="/user/dashboard">
              <img src={backIcon} alt="Back" className={classes.backIcon} />
            </Link>
            <Box className={classes.logoWrapper}>
            <img src={logo} alt="Logo" className={classes.logo} />
            </Box>
          </Box>
          <Box className={classes.pagetitle}>

            <Typography variant="h5" className={classes.communityHeading}>
              Setting and Preferences
            </Typography>

          </Box>

          <Typography
            variant="h3"
            className={classes.mainTitle}
            style={{ marginTop: "20px" }}
          >
            General setting
          </Typography>

          <List className={classes.settingsList}>
            <ListItem className={classes.listItem}>
              <Grid container alignItems="center" spacing={2}>
                <Grid
                  item
                  xs={12}
                  sm={3}
                  md={2}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <AppNotificationIcon width={50} height={50} />
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={9}
                  md={10}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Typography
                    variant="h3"
                    style={{ marginTop: "20px", cursor: "poiner" }}
                    onClick={() => handleGeneralAppSetting('notificationSetting')}
                  >
                    App notification setting
                  </Typography>

                </Grid>
              </Grid>
            </ListItem>
            <ListItem className={classes.listItem}>
              <Grid container alignItems="center" spacing={2}>
                <Grid
                  item
                  xs={12}
                  sm={3}
                  md={2}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",

                  }}
                >
                  <HelpSupportIcon width={50} height={50} />
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={9}
                  md={10}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Typography
                    variant="h3"
                    className={classes.settingList}
                    style={{ marginTop: "20px", cursor: "poiner" }}
                    onClick={() => handleGeneralAppSetting('accessibility')}
                  >
                    Accessibility
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem className={classes.listItem}>
              <Grid container alignItems="center" spacing={2}>
                <Grid
                  item
                  xs={12}
                  sm={3}
                  md={2}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <AppLanguageSettingIcon width={50} height={50} />
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={9}
                  md={10}
                  style={{ display: "flex", alignItems: "center" }}
                ><Typography
                  variant="h3"
                  className={classes.settingList}
                  style={{ marginTop: "20px", cursor: "poiner" }}
                  onClick={() => handleGeneralAppSetting('language')}
                >
                    Select Your Language
                  </Typography>

                </Grid>
              </Grid>
            </ListItem>
          </List>
        </MuiCard>
      </div>
    </>
  );
}

export default AppSetting;
